export const CHECK_PASSWORD_STRENGTH = 'CHECK_PASSWORD_STRENGTH';
export const FETCH_PASSWORD_STRENGTH_REQUEST = 'FETCH_PASSWORD_STRENGTH_REQUEST';
export const FETCH_PASSWORD_STRENGTH_COMPLETED = 'FETCH_PASSWORD_STRENGTH_COMPLETED';
export const SET_REQUIREMENTS_ARE_MET = 'SET_REQUIREMENTS_ARE_MET';
export const UNSET_REQUIREMENTS_ARE_MET = 'UNSET_REQUIREMENTS_ARE_MET';
